/**
 * Static feature-flag config for the terminal.
 *
 * Deferred / not-yet-shipped controls are gated here so they can land dark
 * and be flipped on cleanly later, rather than shipping as silent dead
 * buttons. Each flag carries an optional user-facing `reason` used by
 * <FeatureGate> to render an honest "coming soon" tooltip.
 *
 * This is intentionally a simple compile-time map for now; it can grow into
 * a runtime/remote source later without changing call sites.
 */

export interface FeatureFlagMeta {
  /** Whether the gated control is enabled and should render live. */
  enabled: boolean;
  /** Short user-facing reason shown in the "coming soon" tooltip. */
  reason?: string;
}

export const FEATURE_FLAGS = {
  /** Agent composer: @mention picker for symbols/positions. */
  "agent.composer.mention": {
    enabled: false,
    reason: "@mention · coming soon",
  },
  /** Agent composer: attach a file to the message. */
  "agent.composer.attach": {
    enabled: false,
    reason: "Attach file · coming soon",
  },
  /** Broker onboarding: create a demo account. */
  "broker.demoAccount": {
    enabled: false,
    reason: "Demo accounts are coming soon",
  },
} as const satisfies Record<string, FeatureFlagMeta>;

export type FeatureFlagKey = keyof typeof FEATURE_FLAGS;

export function getFeatureFlag(key: FeatureFlagKey): FeatureFlagMeta {
  return FEATURE_FLAGS[key];
}
